<template>
	<div>
		
		<div class="bg-top"></div>
		<div class='wrapper'>
	
			<main-nav></main-nav>
			<page-hero></page-hero>
			
			<page-intro></page-intro>
			<page-about></page-about>
			<page-project></page-project>
			<page-skill></page-skill>
			

			
			
			
			


		</div>
		
		<page-footer></page-footer>

	</div>
</template>
<script>
//import SideNav from '@/components/SideNav';
import MainNav from '@/components/MainNav';
import PageHero from '@/views/home/Hero';
import PageIntro from '@/views/home/Intro';
import PageAbout from '@/views/home/About';
import PageProject from '@/views/home/Project';
import PageSkill from '@/views/home/Skill';
import PageFooter from '@/views/home/Footer';




export default {

	data: function () {
		return {
			whatSkill:0,
		}
	},
	
	components:{
		MainNav,
		PageHero,
		PageIntro,
		PageAbout,
		PageProject,
		PageSkill,
		PageFooter,



	},



	

}
</script>

